import { render, staticRenderFns } from "./SsBeneficiaryPage.vue?vue&type=template&id=4488bd30"
import script from "./SsBeneficiaryPage.vue?vue&type=script&lang=ts"
export * from "./SsBeneficiaryPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports